import { Pagination } from "antd";
import { useEffect, useState } from "react";
import SortingArrow from "../../../../Common/SortingArrow";
import toast from "react-hot-toast";
import globalRequest from "../../../../utils/global/globalRequest";
import * as Apis from "../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit, paginationPages } from "../../../../utils/helper/constants";
import { changeLoader } from "../../../../redux/reducers/loader";
import { Link } from "react-router-dom";
import { formatDateFunction, getTabFromOrderStatus } from "../../../../utils/helper/utils";

const SalesDetailsReport = ({ inputData, setInputData }) => {
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [totalRows, setTotalRows] = useState(0); 

  const getAllSalesReports = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_SALES_DETAILS_REPORT, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let resultData = [];
        if (apiResponse?.data?.data?.length > 0) {
          for (let item of apiResponse?.data?.data) {
            let dropZoneName = "-";
            let dropZoneZoneName = "-";
            let zoneName = "-";

            if (Array.isArray(item?.pickupPointDetails?.dropZoneLocales)) {
            const enDropZone = item.pickupPointDetails.dropZoneLocales.find(
                (dz) => dz.languageCode === "en"
            );
            dropZoneZoneName = item.pickupPointDetails.zoneDetails.find(
                (dz) => dz.name
            );
            dropZoneName = enDropZone?.name || "-";
            }
            let vendorName = "N/A";

            if (Array.isArray(item?.orderDetails) && item.orderDetails.length > 0) {
            const vendorDetails = item.orderDetails[0]?.vendorDetails;
            vendorName =  `${vendorDetails?.firstName || ""} ${vendorDetails?.lastName || ""}`.trim() || "N/A";
            }
            if (item?.branchDetails?.zoneDetails?.length > 0) {
            const zoneDetails = item.branchDetails.zoneDetails[0];
            zoneName = zoneDetails?.name || "N/A";
            }
            resultData.push({
                orderNumber: item?.orderNumber,
                branchName: item?.branchDetails?.name || "N/A",
                vendorName: vendorName,
                driverName: item?.driverDetails?.driverName || "N/A",
                deliveryMode: item?.deliveryMode,
                dropzone: dropZoneName,
                zoneName: zoneName || "N/A",
                customerZoneName: item?.customerZoneDetails[0]?.name || dropZoneZoneName.name ||"N/A",
                totalQuantity: item?.totalQuantity,
                totalAmount: item?.totalAmount,
                deliveryDate: item?.deliveryDate ? formatDateFunction(item?.deliveryDate, "dd/mm/yyyy") : "N/A",
                paymentMethod: item?.paymentMethod ?.replace(/_/g, " ") ?.replace(/\b\w/g, c => c.toUpperCase()) || "N/A",
                status: item?.status,
                orderDate: formatDateFunction(item?.createdAt, "dd/mm/yyyy"),
            });
          }
        }
        setList(resultData);
        setTotalRows(apiResponse?.data?.paginator?.itemCount || 0);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllSalesReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleSort = (column, order) => {
    console.log("column", column, "order", order);
    setInputData((prev) => ({
      ...prev,
      orderBy: column,
      orderType: order,
    }));
  };

  return (
    <>
      <div className="relative overflow-x-auto">
        <table className="w-full  text-left	 text-sm  text-gray-500">
          <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
            <tr>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Order Number <SortingArrow onSort={(order) => handleSort("orderNumber", order)} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Branch Name <SortingArrow onSort={(order) => handleSort("branchName", order)} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Vendor Name
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Driver Name
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Delivery Mode
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Dropzone
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Customer Zone
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Branch Zone
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Payment Method
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Status
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Total Amount
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Order Date <SortingArrow onSort={(order) => handleSort("amount", order)} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Delivery Date
                <SortingArrow onSort={(order) => handleSort("paymentStatus", order)} />
              </th>
              
            </tr>
          </thead>
          <tbody>
            {list?.length > 0 &&
                list.map((item, index) => (
                <tr key={index} className="bg-white border-b">
                    <td className="px-3 py-4 whitespace-nowrap">
                    <Link
                        to={`/order-management/?order_number=${item.orderNumber}`}
                        state={{
                        orderNumber: item.orderNumber,
                        activeTab: getTabFromOrderStatus(item.status),
                        }}
                        style={{ color: "#37846B", fontWeight: 500 }}
                    >
                        {item.orderNumber}
                    </Link>
                    </td>

                    <td className="px-3 py-4">{item.branchName}</td>
                    <td className="px-3 py-4">{item.vendorName}</td>
                    <td className="px-3 py-4">{item.driverName}</td>
                    <td className="px-3 py-4 capitalize">{item.deliveryMode}</td>
                    <td className="px-3 py-4">{item.dropzone}</td>
                    <td className="px-3 py-4">{item.customerZoneName}</td>
                    <td className="px-3 py-4">{item.zoneName}</td>
                    <td className="px-3 py-4 capitalize">{item.paymentMethod}</td>
                    <td className="px-3 py-4 capitalize">{item.status}</td>

                    <td className="px-3 py-4">
                    {item.totalAmount} SAR
                    </td>

                    <td className="px-3 py-4">{item.orderDate}</td>
                    <td className="px-3 py-4">{item.deliveryDate}</td>
                </tr>
                ))}
            </tbody>
        </table>
      </div>

      <div className="text-right mt-4">
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) => setPaginationModel((prev) => ({ ...prev, page: page }))}
              onShowSizeChange={(current, size) => setPaginationModel((prev) => ({ ...prev, limit: size }))}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};
export default SalesDetailsReport;
